const minValue = 1.5
const maxValue = 5

export { minValue, maxValue }